<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内部管理</el-breadcrumb-item>
      <el-breadcrumb-item>豆迈科技</el-breadcrumb-item>
      <el-breadcrumb-item>豆迈科技用户管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.phone" @keyup.enter.native="clicksearch" placeholder="请输入手机号码" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.sn" @keyup.enter.native="clicksearch" placeholder="请输入保修卡号" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table :data="dataList" border stripe>
          <el-table-column prop="Id" label="编号" min-width="5%"></el-table-column>
          <el-table-column prop="Age" label="年龄" min-width="5%"></el-table-column>
          <el-table-column prop="Phone" label="手机号码" min-width="10%"></el-table-column>
          <el-table-column prop="Sn" label="保修卡号" min-width="10%"></el-table-column>
          <el-table-column prop="Setnum" label="度数设置剩余次数" min-width="10%"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" min-width="15%"></el-table-column>
          <el-table-column prop="operation" label="操作" min-width="8%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickChangeSn(scope.row)">修改</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickUnbindSn(scope.row)">清空SN</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickOldSnList(scope.row)">更换记录</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goTimeView(scope.row)">时长记录</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goViewVisionReview(scope.row)">视力复查管理</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
            :current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

      <!-- 新增 start -->
      <el-tab-pane label="新增" name="third">
        <el-form :model="addForm" ref="addFormRef" label-width="170px">
          <el-form-item label="年龄" class="addAdminForm">
            <el-input v-model="addForm.age"></el-input>
          </el-form-item>
          <el-form-item label="手机号码" class="addAdminForm">
            <el-input v-model="addForm.phone"></el-input>
          </el-form-item>
          <el-form-item label="密码" class="addAdminForm">
            <el-input v-model="addForm.pwd"></el-input>
          </el-form-item>
          <el-form-item label="保修卡号" class="addAdminForm">
            <el-input v-model="addForm.sn"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="apiDouMaiKeJiGlassuserAdd">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 新增 end -->

      <!-- 换绑 start -->
      <el-tab-pane label="换绑" name="second" disabled="disabled">
        <el-form :model="editForm" ref="editFormRef" label-width="220px">
          <el-form-item label="年龄" class="addAdminForm">
            <el-input v-model="editForm.age"></el-input>
          </el-form-item>
          <el-form-item label="度数设置剩余次数" class="addAdminForm">
            <el-input v-model="editForm.setnum"></el-input>
          </el-form-item>
          <el-form-item label="新保修卡号(需要修改时再填写)" class="addAdminForm">
            <el-input v-model="editForm.sn"></el-input>
          </el-form-item>
          <el-form-item label="新密码(需要修改时再填写)" class="addAdminForm">
            <el-input v-model="editForm.newpwd"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksave">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 换绑 end -->

      <!-- 保修卡号更换记录 start -->
      <el-tab-pane label="保修卡号更换记录" name="three" disabled="disabled">
        <el-button type="primary" @click="clickreturn">返回</el-button>
        <!-- 数据列表 start -->
        <el-table :data="dataOldSnList" border stripe>
          <el-table-column prop="Oldsn" label="旧保修卡号" min-width="10%"></el-table-column>
          <el-table-column prop="Newsn" label="新保修卡号" min-width="10%"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" min-width="15%"></el-table-column>
        </el-table>
        <!-- 数据列表 end -->
      </el-tab-pane>
      <!-- 保修卡号更换记录 end -->

      <el-tab-pane label="时长记录" name="four" disabled="disabled">
        <RslEvUserTime ref="SubVueFour" v-on:triggerFunc="BackToFirst"></RslEvUserTime>
      </el-tab-pane>

      <el-tab-pane label="视力复查管理" name="seven" disabled="disabled">
        <DouMaiKeJiUserFuCha ref="SubVueseven" v-on:triggerFunc="BackToFirst"></DouMaiKeJiUserFuCha>
      </el-tab-pane>

  </el-tabs>
  </div>
</template>

<script>
import RslEvUserTime from '@/componentsSubVue/RslEvUserTime.vue'
import DouMaiKeJiUserFuCha from '@/componentsSubVue/DouMaiKeJiUserFuCha.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    RslEvUserTime,
    DouMaiKeJiUserFuCha
  },
  name: 'MyMiniProgramDouMaiKeJiGlassUsers',
  data () {
    return {
      activeName: 'first',
      addForm: {
        age: '',
        phone: '',
        pwd: '',
        sn: ''
      },
      editForm: {
        glassuserid: '',
        age: '',
        setnum: '',
        sn: '',
        newpwd: ''
      },
      // 查询
      keywords: {
        phone: '',
        sn: ''
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1,
      dataOldSnList: []
    }
  },
  mounted () {
    this.apiDouMaiKeJiGlassuserGetNum()
    this.apiDouMaiKeJiGlassuserGetList()
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiDouMaiKeJiGlassuserGetNum()
      this.apiDouMaiKeJiGlassuserGetList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiDouMaiKeJiGlassuserGetList()
    },
    clickChangeSn (row) {
      this.activeName = 'second'
      this.editForm.glassuserid = row.Id
      this.editForm.age = row.Age
      this.editForm.setnum = row.Setnum
    },
    clickUnbindSn (row) {
      this.editForm.glassuserid = row.Id
      this.$confirm('是否清空SN?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDouMaiKeJiGlassuserUnbind()
      })
    },
    clickOldSnList(row){
      this.activeName = "three"
      this.apiDouMaiKeJiGlassuserOldSnGetList(row.Id)
    },
    goTimeView(row){
      this.activeName = 'four'
      this.$refs.SubVueFour.LoadData(row,'豆迈科技')
    },
    clicksave () {
      this.apiDouMaiKeJiGlassuserNewSn()
    },
    clickreturn () {
      this.activeName = 'first'
      this.apiDouMaiKeJiGlassuserGetNum()
      this.apiDouMaiKeJiGlassuserGetList()
    },
    // 视力复查
    goViewVisionReview (row) {
      this.activeName = 'seven'
      this.$refs.SubVueseven.LoadData(row)
    },
    apiDouMaiKeJiGlassuserGetNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        phone: that.keywords.phone,
        sn: that.keywords.sn
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DouMaiKeJiGlassuserGetNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDouMaiKeJiGlassuserGetList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        phone: that.keywords.phone,
        sn: that.keywords.sn
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DouMaiKeJiGlassuserGetList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDouMaiKeJiGlassuserOldSnGetList: function (glassuserid) {
      var that = this
      that.dataOldSnList = []
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: glassuserid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DouMaiKeJiGlassuserOldSnGetList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataOldSnList = response.data.List
          }
          console.log(response.data)
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDouMaiKeJiGlassuserNewSn: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      data = { ...data, ...that.editForm }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DouMaiKeJiGlassuserNewSn, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiDouMaiKeJiGlassuserGetNum()
            that.apiDouMaiKeJiGlassuserGetList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDouMaiKeJiGlassuserUnbind: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      data = { ...data, ...that.editForm }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DouMaiKeJiGlassuserUnbind, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.apiDouMaiKeJiGlassuserGetNum()
            that.apiDouMaiKeJiGlassuserGetList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDouMaiKeJiGlassuserAdd: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      data = { ...data, ...that.addForm }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DouMaiKeJiGlassuserAdd, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
</style>
